/* REALTIME */

import { invalidateIntegrationRequestCache } from '@lifen-integration/features/integrationRequests/hooks';
import { invalidateIntegrationRequestsCacheQueries } from '@lifen-integration/hooks/useIntegrationRequests';
import { logger } from '@services/logger/logger.service';

import {
  IntegrationRealtimeCommunicationRequestUpdated,
  integrationRealtimeCommunicationRequestUpdated,
  integrationRealtimeCommunicationUpdated,
} from '@store/externalEvents/externalEvents.action';
import { QueryClient } from '@tanstack/react-query';
import { all, call, debounce, getContext } from 'redux-saga/effects';

const DEBOUNCE_DELAY_MS = 500;

function* refreshIntegrationRequestSaga({
  payload,
}: ReturnType<IntegrationRealtimeCommunicationRequestUpdated>) {
  try {
    const documentId = payload.resource.id;
    if (!documentId) return;

    logger.info('LOGIC', `[realtime] refreshing integration request id: ${documentId}`);

    const queryClient: QueryClient = yield getContext('queryClient');

    yield call(invalidateIntegrationRequestCache, queryClient, documentId);
    yield call(invalidateIntegrationRequestsCacheQueries, queryClient);
  } catch (err) {
    logger.error('LOGIC', '[realtime] Failed to refresh integration request', err);
  }
}

export function* integrationRequestRealtimeSagas() {
  yield all([
    debounce(
      DEBOUNCE_DELAY_MS,
      integrationRealtimeCommunicationRequestUpdated.type,
      refreshIntegrationRequestSaga,
    ),
    debounce(
      DEBOUNCE_DELAY_MS,
      integrationRealtimeCommunicationUpdated.type,
      refreshIntegrationRequestSaga,
    ),
  ]);
}
